import { useMemo } from 'react'

import type { Box } from '@library/menu-service/queries/menuApiBoxes/types'

import { useBoxes } from './useBoxes'

const DEFAULT_MAX_RECIPES = 4

export const useMaxRecipesForPortion = (numberOfPortions = 2) => {
  const { boxes } = useBoxes()

  return useMemo(() => {
    const filteredBoxes = boxes.filter((box: Box) => box.numberOfPortions === numberOfPortions)
    const recipeCounts = filteredBoxes.map((box: Box) => box.numberOfRecipes)
    const hasRecipeCounts = recipeCounts?.length > 0

    return hasRecipeCounts ? Math.max(...recipeCounts) : DEFAULT_MAX_RECIPES
  }, [boxes, numberOfPortions])
}
